<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ provider.name }}
            </h5>
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0">
            {{ provider.code }}
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">{{ provider.balance }} &euro;</div>

          <div class="hidden lg:block w-48 lg:text-right px-4">
            {{ dateCreated }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <!-- <button
          :disabled="disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600
          hover:bg-blue-600 hover:text-white focus:outline-none
          disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('provider:view', provider)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    provider: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    dateCreated() {
      return moment(this.provider.created_at).format('DD/MM/YYYY');
    },
  },
};
</script>
